'use client';

import dynamic from 'next/dynamic';
import useIsBrowser from 'hooks/useIsBrowser';

// ChatWidgetsInner is client-only: it boots the Kustomer chat SDK (window.*),
// reads navigator/OneTrust consent, and renders nothing (returns null).
// It used to be loaded with `dynamic(..., { ssr: false })`, which makes React
// emit a `<template data-dgst="BAILOUT_TO_CLIENT_SIDE_RENDERING">` boundary in
// the homepage server HTML and adds an ssr:false bailout slot to the Partial
// Prerender shell. Since the widget renders null anyway, we defer it until the
// component has mounted in the browser instead (useIsBrowser): the server and
// the first client render both produce null (no bailout marker, no hydration
// mismatch), and the dynamic chunk loads after mount exactly as before. This
// removes the homepage CSR bailout without changing behaviour or trying to
// server-render window-only code. (CON-8267)
const ChatWidgetsInner = dynamic(() => import('./ChatWidgetsInner'));

export default function ChatWidgets() {
  const isBrowser = useIsBrowser();

  if (!isBrowser) {
    return null;
  }

  return <ChatWidgetsInner />;
}
